import type { EndAdministration, EndAdministrationInput } from 'generated/gql';

import { mapShareSeriesToShareSeriesInput } from './ShareSeries';

export const mapEndAdministrationToEndAdministrationInput = (
  endAdministration: EndAdministration,
): EndAdministrationInput => ({
  ownerPartyId: endAdministration.owner.id,
  shareSeries: mapShareSeriesToShareSeriesInput(endAdministration.shareSeries),
});
